import { Component, Output, EventEmitter, OnInit, Input, ElementRef, ApplicationRef, AfterViewInit } from '@angular/core';
import { SessionService } from '../shared/services/session.service';
import { MatSnackBar } from "@angular/material";
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import * as $ from "jquery";

import { AlfabetetAaComponent } from '../yr3-tincan/alfabetstavlor/alfabetet-aa/alfabetet-aa.component';
import { BladderblocketComponent } from '../yr3-tincan/bladderblocket/bladderblocket.component';
import { BorjorComponent } from '../yr3-tincan/borjor/borjor.component';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']

})
export class NavMenuComponent implements OnInit, AfterViewInit {

  @Output() closeNavEvent = new EventEmitter<string>();
  closeNavChild(): void {
    this.closeNavEvent.next();
  }


  @Output() openNavEvent = new EventEmitter<string>();
  openNavChild(): void {
    this.openNavEvent.next();
  }

  dialogResult = "";
  public firstName: string;
  public lastName: string;
  public currentRoute: string;
  public title: string;
  public version: string;
  public webApiEndPoint: string;
  public bloburl: string;
  public logurl: string;

  constructor(public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private sessionService: SessionService,

    private router: Router
   ) {

    this.logurl = this.sessionService.logouturl;
    this.bloburl = this.sessionService.bloburl;
    var current_url = "";
    var old_url = "";
    this.router.events.subscribe((val) => {
      current_url = this.router.url;
      if (current_url != old_url) {
       this.setmenulayout();
        this.menuactive();
        old_url = current_url;
      }
    });

  }
  menuactive() {


    var a = $("#menu_ReadBook_img").width();
    var b = $("#menu_ReadBook_img").height();
    var width_sub = 3;
    var height_add = 20;
    if (a > 0 && b > 0) {
      $("#menu_ReadBook_active").width((a - width_sub) + "px");
      $("#menu_ReadBook_active").height((b + height_add) + "px");
      var a = $("#menu_WorkBook_img").width();
      var b = $("#menu_WorkBook_img").height();
      $("#menu_WorkBook_active").width((a - width_sub) + "px");
      $("#menu_WorkBook_active").height((b + height_add) + "px");

    }
  }
  setmenulayout() {
   
  }
    
  setmenuactive() {


   var page_active = this.router.url;

    var readbooks_url = ["/yr3-rb-index",    


        "/rbpagech06/yr3-rb-pgs-ch06-page76",
        "/rbpagech06/yr3-rb-pgs-ch06-page77",
        "/rbpagech06/yr3-rb-pgs-ch06-page78",
        "/rbpagech06/yr3-rb-pgs-ch06-page79",
        "/rbpagech06/yr3-rb-pgs-ch06-page80",
        "/rbpagech06/yr3-rb-pgs-ch06-page81",
        "/rbpagech06/yr3-rb-pgs-ch06-page82",
        "/rbpagech06/yr3-rb-pgs-ch06-page83",
        "/rbpagech06/yr3-rb-pgs-ch06-page84",
        "/rbpagech06/yr3-rb-pgs-ch06-page85",

      
       
    ];

    var workbooks_url = [
      "/yr3-wb-index",      
      

      "/wbpagech06/yr3-wb-pgs-ch06-page47",
      "/wbpagech06/yr3-wb-pgs-ch06-page48",
      "/wbpagech06/yr3-wb-pgs-ch06-page49",
      "/wbpagech06/yr3-wb-pgs-ch06-page50",
      "/wbpagech06/yr3-wb-pgs-ch06-page51",
      "/wbpagech06/yr3-wb-pgs-ch06-page51-a",
      "/wbpagech06/yr3-wb-pgs-ch06-page52",
      "/wbpagech06/yr3-wb-pgs-ch06-page53",
      "/wbpagech06/yr3-wb-pgs-ch06-page54",    

      
      ]


    $("#menu_ReadBook_active").hide();
    $("#menu_WorkBook_active").hide();

    if (readbooks_url.indexOf(page_active) > - 1) {
      $("#menu_ReadBook_active").css("display", "block");
    }
    else if (workbooks_url.indexOf(page_active) > - 1) {
      $("#menu_WorkBook_active").css("display", "block");
    }
    $(".rb_ch").hide();
        $(".wb_ch").hide();
    
    var other_url = [
      "/yr3-starting-page",
      "/"
    ];
     
    

     var workbookch6_url = [
       "/wbpagech06/yr3-wb-pgs-ch06-page47",
      "/wbpagech06/yr3-wb-pgs-ch06-page48",
      "/wbpagech06/yr3-wb-pgs-ch06-page49",
      "/wbpagech06/yr3-wb-pgs-ch06-page50",
      "/wbpagech06/yr3-wb-pgs-ch06-page51",
      "/wbpagech06/yr3-wb-pgs-ch06-page51-a",
      "/wbpagech06/yr3-wb-pgs-ch06-page52",
      "/wbpagech06/yr3-wb-pgs-ch06-page53",
      "/wbpagech06/yr3-wb-pgs-ch06-page54",
     
    ];


    

      var readbookch6_url = [
          "/rbpagech06/yr3-rb-pgs-ch06-page76",
          "/rbpagech06/yr3-rb-pgs-ch06-page77",
          "/rbpagech06/yr3-rb-pgs-ch06-page78",
          "/rbpagech06/yr3-rb-pgs-ch06-page79",
          "/rbpagech06/yr3-rb-pgs-ch06-page80",
          "/rbpagech06/yr3-rb-pgs-ch06-page81",
          "/rbpagech06/yr3-rb-pgs-ch06-page82",
          "/rbpagech06/yr3-rb-pgs-ch06-page83",
          "/rbpagech06/yr3-rb-pgs-ch06-page84",
          "/rbpagech06/yr3-rb-pgs-ch06-page85"
      ];

      


    if (other_url.indexOf(page_active) > -1) {
      $(".rb_ch").hide();
    }
   
    else if (workbookch6_url.indexOf(page_active) > -1) {
      $(".wb_ch_6").show();
      $(".rb_ch_6").show();
    }
    
      if (readbookch6_url.indexOf(page_active) > -1) {
           $(".rb_ch_6").show();
           $(".wb_ch_6").show();
      }
    

  }

  async ngAfterViewInit() {

  }


  public ngOnInit() {
    document.addEventListener("touchstart", function () { }, false);
       var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
    var isEdge = window.navigator.userAgent.indexOf("Edge") > -1;


    if (isIE11 === true || isEdge === true) {
    

     $('#menu_Tillaren').click(function (e) {
      
        $(".dropdown-content_Tillaren").show();
      });

      $('.dropdown1_Tillaren').click(function (e) {
       
        $(".dropdown-content1_Tillaren").show();
      });

      $('.dropdown-content1_Tillaren_close').click(function (e) {
       
        $(".dropdown-content1_Tillaren").hide();
      });

    $(".foo").click(function () {
      
        var open_close = $(".dropdown-content_tincan").css("display");
        $(".tincan1").css("display", "none");
        $(".tincan2").css("display", "inline-block");
        $(".dropdown-content_tincan").css("display", "block");
      });


      $('.dropdown1_tincan').click(function (e) {
        
        $(".dropdown-content1_tincan").show();
      });

      $('.dropdown-content1_tincan_close').click(function (e) {
     
        $(".dropdown-content1_tincan").hide();
      });
      $('.dropdown2_tincan').click(function (e) {
      
        $(".dropdown-content2_tincan").show();
      });

      $('.dropdown-content2_tincan_close').click(function (e) {
        $(".dropdown-content2_tincan").hide();
      });

      $('.dropdown3_tincan').click(function (e) {
      
        $(".dropdown-content3_tincan").show();
      });

      $('.dropdown-content3_tincan_close').click(function (e) {
        $(".dropdown-content3_tincan").hide();
      });

      $('.dropdown4_tincan').click(function (e) {
       
        $(".dropdown-content4_tincan").show();
      });

      }
        //auto active menu bar
        var current_url = "";
        var old_url = "";
        this.router.events.subscribe((val) => {
            current_url = this.router.url;
            if (current_url != old_url) {
                this.setmenuactive();
                this.setmenulayout();
                old_url = current_url;
            }
        });
    }

 

  LH6() {
    let link = this.bloburl + '/Lasresan/AK3/YR3-Tilllararen/Lararhandledning/Pdf/LH.kap.6.pdf#toolbar=0';
    window.open(link, "_blank", "fullscreen=yes");
  }
  

  openAlfabetetAa() {
    this.dialog.open(AlfabetetAaComponent, {
    disableClose: true
  });
 }

  openbladderblocket() {
    this.dialog.open(BladderblocketComponent, {
      disableClose: true
    });
  }

  openborjor() {
    this.dialog.open(BorjorComponent, {
      disableClose: true
    });
  }
 
}



